var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuides(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1269 16.8538H28.5094M19.1269 23.1089H28.5094M19.1269 29.3639H28.5094M3.48926 5.90751C3.48926 5.49278 3.65401 5.09503 3.94727 4.80177C4.24054 4.5085 4.63828 4.34375 5.05302 4.34375H26.9457C27.3604 4.34375 27.7582 4.5085 28.0514 4.80177C28.3447 5.09503 28.5094 5.49278 28.5094 5.90751V9.03503C28.5094 9.44977 28.3447 9.84752 28.0514 10.1408C27.7582 10.434 27.3604 10.5988 26.9457 10.5988H5.05302C4.63828 10.5988 4.24054 10.434 3.94727 10.1408C3.65401 9.84752 3.48926 9.44977 3.48926 9.03503V5.90751ZM3.48926 18.4176C3.48926 18.0029 3.65401 17.6051 3.94727 17.3119C4.24054 17.0186 4.63828 16.8538 5.05302 16.8538H11.3081C11.7228 16.8538 12.1205 17.0186 12.4138 17.3119C12.7071 17.6051 12.8718 18.0029 12.8718 18.4176V27.8002C12.8718 28.2149 12.7071 28.6127 12.4138 28.9059C12.1205 29.1992 11.7228 29.3639 11.3081 29.3639H5.05302C4.63828 29.3639 4.24054 29.1992 3.94727 28.9059C3.65401 28.6127 3.48926 28.2149 3.48926 27.8002V18.4176Z",
    stroke: "url(#paint0_linear_859_3471)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_859_3471",
    x1: 6.64262,
    y1: -11.0777,
    x2: 35.5694,
    y2: -5.16283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuides);
export default __webpack_public_path__ + "static/media/guides.0636d1d032ec3e94847edcd4a655993c.svg";
export { ForwardRef as ReactComponent };